// What Market and Cash flow open with. Each is kept for the session, and the
// shell loads them ahead (`usePrefetch`), so a visit paints at once.

import { netWorthQuery } from "@/finance/ui/queries/balances.js";
import { cashflowFlowsQuery, comparisonLayoutQuery } from "@/finance/ui/queries/cashflow.js";
import { marketNewsQuery, portfolioPerformanceQuery } from "@/finance/ui/queries/investments.js";
import {
  deploymentSignalQuery,
  marketSourceQuery,
  watchlistQuery,
} from "@/finance/ui/queries/market.js";

export const dashboardQueries = [
  marketSourceQuery,
  watchlistQuery,
  deploymentSignalQuery,
  portfolioPerformanceQuery,
  marketNewsQuery,
  cashflowFlowsQuery,
  netWorthQuery,
  comparisonLayoutQuery,
] as const;
